export enum ProductType {
  KKC = 'KKC',
  CL = 'CL',
  CMC = 'CMC',
}

export enum ProductName {
  KKC = 'ClearCardCredit',
  CL = 'CashLoan',
  CMC = 'CMCash',
}

export enum ThirdPartnerCode {
  MyLink = 'MyLink',
}

export enum AppName {
  CreFit = 'CreFit',
  BillManagement = 'BillManagement',
}

export enum ProductLabel {
  DS = 'DS',
  DC = 'DC',
  TipTop = 'TipTop',
  WhatsAppFlow = 'WhatsApp_Flow',
  DC01 = 'DC01',
}

export enum SpecialChannel {
  TipTop = 'TipTop',
  WhatsAppFlow = 'WhatsApp_Flow',
  CS = 'CS',
  Capi = 'Capi',
}

export type H5Channel = string | SpecialChannel;
